/**
 * The big skill icon peeking in from a daily-quiz card's right edge, so 听 / 读写 /
 * 说 read apart at a glance, before a word is read: headphones, a pencil, a mic.
 * Colour comes from the card's skill class (DailyTestCard.css, .dt-card--*).
 *
 * @param {{ skill: 'listening'|'readwrite'|'speaking' }} props
 */
const PATHS = {
  listening: (
    <>
      <path d="M4 14a8 8 0 0 1 16 0" />
      <rect x="3" y="13" width="4" height="7" rx="2" fill="currentColor" fillOpacity=".18" />
      <rect x="17" y="13" width="4" height="7" rx="2" fill="currentColor" fillOpacity=".18" />
    </>
  ),
  readwrite: (
    <>
      <path d="M4 20l1-4L16 5l3 3L8 19z" fill="currentColor" fillOpacity=".18" />
      <path d="M14 7l3 3" />
    </>
  ),
  speaking: (
    <>
      <rect x="9" y="3" width="6" height="11" rx="3" fill="currentColor" fillOpacity=".18" />
      <path d="M5 11a7 7 0 0 0 14 0M12 18v3M9 21h6" />
    </>
  ),
};

export function QuizSkillPeek({ skill }) {
  const paths = PATHS[skill];
  if (!paths) return null;
  return (
    <span className="dt-card-peek" aria-hidden="true">
      <svg viewBox="0 0 24 24" width="42" height="42" fill="none" stroke="currentColor"
        strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
        {paths}
      </svg>
    </span>
  );
}

export default QuizSkillPeek;
